export default __webpack_public_path__ + "img/b3bbea77ee24cc2fc0dd863928f89f1e.png";